export default "__VITE_ASSET__H5flsKys__"